exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-avatar > img {\n  display: block;\n  height: 70%;\n  object-fit: cover;\n  -webkit-transform: translate(29%, 18%);\n          transform: translate(29%, 18%);\n}\n", ""]);

// exports
